import * as React from "react";

import "./mailing-lists-panel.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {Responsive}     from "@Common/ui-components/responsive";
import {MlTable}        from "./ml-table/ml-table";
import {MlColumn}       from "./ml-column/ml-column";

import {MailingListGrid} from "../mailing-lists-grid/mailing-lists-grid";

export const MailingListsPanel = ({entityId = undefined}) => cs(
    consumeContext("apis"),
     // @ts-ignore
     ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["mailingLists", ({apis}, next) => Load2({
        fetch: async () => {
            const mailingList = await apis.next.mailing.getMailingLists({entityId})
            return mailingList
        },
        next,
    })],
    ({mailingLists, responsive}) => (
        <div className="mailing-lists-panel-61k">
            {
                MailingListGrid({entityId, mailingLists})
            }
            {
                responsive.lt("md") ? (
                    MlColumn({entityId, mailingLists})
                ) : (
                    MlTable({entityId, mailingLists})
                )
            }
        </div>
    )
);
